import baseUrl from "./baseUrl";

function previewConfig(data) {
  return {
    method: "post",
    url: `${baseUrl}/api/v1/dashboard/getView`,
    headers: {
      Accept: "application/json",
    },
    data: data,
  };
}

export default previewConfig;
